// extracted by mini-css-extract-plugin
module.exports = {"root":"Jb0sbIVt","title":"THHkdi4e","button":"xCVtIfZz","bg":"SqqD8aV0"};